import { assign } from 'lodash'

export default class CatchmentPointDto {
    constructor(obj) {
        assign(this, obj)
        this.codeWithoutDesignation = obj.code.split('/')[0]

        // this.id = obj.id // Int
        // this.code = obj.code // String
        // this.owner = obj.owner // Option[Int]
        // this.mainPoint = obj.mainPoint // Option[Boolean]
    }
}